import { useState, useEffect, useRef } from 'react';

export const usePyodide = () => {
  const [output, setOutput] = useState<string[]>([]);
  const [isRunning, setIsRunning] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const workerRef = useRef<Worker | null>(null);

  useEffect(() => {
    // Initialize the Web Worker
    workerRef.current = new Worker(new URL('../workers/pyodide.worker.ts', import.meta.url));

    // Listen for messages from the worker
    workerRef.current.onmessage = (event) => {
      const { type, data } = event.data;

      if (type === 'status' && data === 'ready') {
        setIsReady(true); // Correct way to update state
      }
      if (type === 'stdout') {
        setOutput(prev => [...prev, data]);
      }
      if (type === 'stderr') {
        setOutput(prev => [...prev, `<span style="color:#f87171">${data}</span>`]);
      }
      if (type === 'done') {
        setIsRunning(false);
      }
    };

    // Cleanup worker on unmount
    return () => {
      workerRef.current?.terminate();
    };
  }, []);

  const runPython = (script: string, files: any[], activeFileId: string) => {
    if (!workerRef.current) return;
    setIsRunning(true);
    workerRef.current.postMessage({
      type: 'run',
      script,
      files,
      activeFileId
    });
  };

  const clearOutput = () => setOutput([]);

  return { output, isRunning, isReady, runPython, clearOutput };
};